import { Component, Input } from '@angular/core';

import { IconStyleEnum } from '~/component/icon/enums/icon-style.enum';
import { IconTypeEnum } from '../icon/enums/icon-type.enum';

import { SocialButtonVariantEnum } from './enums/variant.enum';

@Component({
  selector: 'app-social-button',
  templateUrl: './social-button.component.html',
  styleUrls: ['./social-button.component.scss'],
})
export class SocialButtonComponent {
  @Input() public ariaLabel?: string;
  @Input() public iconStyle: IconStyleEnum;
  @Input() public iconType: IconTypeEnum;
  @Input() public name: string;
  @Input() public url: string;
  @Input() public variant = SocialButtonVariantEnum.Primary;

  public get className(): string {
    const classes = ['social-button', `social-button--${this.variant}`];

    return classes.join(' ');
  }

  public get isLink(): boolean {
    return !!this.url;
  }
}
